var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_-_bed",
    "data-name": "icon - bed",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.946,
    height: 19.118,
    viewBox: "0 0 25.946 19.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M25.148,0H.8C.358,0,0,.486,0,1.086v5.6c0,.6.358,1.086.8,1.086H.882V9.791c0,.15.089.272.2.272h2.1c.11,0,.2-.122.2-.272V7.774H22.57V9.791c0,.15.089.272.2.272h2.1c.11,0,.2-.122.2-.272V7.774h.083c.441,0,.8-.486.8-1.086v-5.6c0-.6-.357-1.086-.8-1.086",
    transform: "translate(0 9.056)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M2.57,7.346h.642v-2.9a.882.882,0,0,1,.856-.905h6.817a.882.882,0,0,1,.857.905v2.9H14.2v-2.9a.882.882,0,0,1,.856-.905h6.817a.882.882,0,0,1,.857.905v2.9h.642a2.646,2.646,0,0,1,2.57,2.716V2.716A2.646,2.646,0,0,0,23.377,0H2.57A2.646,2.646,0,0,0,0,2.716v7.346A2.646,2.646,0,0,1,2.57,7.346",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBed);
export default __webpack_public_path__ + "static/media/icon-bed.7d352b277d62a451a3138e6c29ef76d0.svg";
export { ForwardRef as ReactComponent };